import { Button } from '@rio-cloud/rio-uikit';
import styled from 'styled-components';

export const SavePreferencesButton = styled(Button)`
  &:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
`;